// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import {Lottie} from '../../../../shared/ui/lottie';

export const Btn_loader = ()=>{
    return <Lottie autoplay loop width="42px" height="16px"
      src={toolip_img_url('animation/button_loader.json')}/>;
};
